// React hooks
import { memo, useEffect, useState } from "react";

// Helpers i API servisi
import { validateYup } from "services/forms/validation/validation";




// Tipovi i konstante
import { Errors } from "services/forms/validation/types";
import { CONTACT_EXPORT_FORM_SCHEMA } from "./validation";
import { ContactExportProps } from "./types";

// UI komponente
import { Button } from "ui/components/Button/Button";
import { Loader } from "ui/components/Loader";
import { Modal } from "ui/components/Modal";

import { initialContactExportForm } from "services/api/contacts/consts";
import { ContactExportFormValues } from "services/api/contacts/types";
import { contactExportAPI } from "services/api/contacts/api";
import { downloadFile } from "helpers";

const ContactExportCard: React.FC<ContactExportProps> = (props) => {
  const { show, onClose, onSuccess } = props;
  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [formValues, setFormValues] = useState<ContactExportFormValues>(
    initialContactExportForm
  );

  useEffect(() => {}, []);

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();

    const isValid = validateYup(
      formValues,
      CONTACT_EXPORT_FORM_SCHEMA,
      setErrors
    );

    if (!isValid) {
      return;
    }

    setIsLoading(true);

    try {
      var result = await contactExportAPI();
      if (result) {
        downloadFile(result, "vcard");
      }
    } catch (e) {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
  };

  return (
    <Modal show={show} onHide={onClose}>
      <div className="flex gap-4">
        <div className="h-full w-full  m-auto">
          <div className="space-y-3">
            <div className="py-5 px-5 flex items-center mb-8 border-b border-slate-200 pb-[-1px]">
              <p className="text-base font-semibold text-slate-600 ">
                Export kontakata
              </p>
            </div>
            <div className="px-5 pb-5 ">
              <form noValidate className="text-left ">
                <div className=" cursor-pointer bg-slate-50  ring-1 ring-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-400 rounded-sm py-4 flex justify-center items-center mb-3">
                  <div className="flex items-center flex-col">
                    <div className="font-medium text-sm text-[#475467] ">
                      Izvezi kontakte klikom na <strong>"Preuzmi datoteku"</strong>. Datoteka će biti izvezena u <strong>.vcard</strong> formatu
                    </div>
                  </div>
                </div>
                <div className="flex justify-end ">
                  <Button
                    variant="primary"
                    size="full"
                    children="Preuzmi datoteku"
                    onClick={handleFormSubmit}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Loader isLoading={isLoading ?? false}> </Loader>
    </Modal>
  );
};
export default memo(ContactExportCard);
